import camelCase from 'lodash/camelCase';
import kebabCase from 'lodash/kebabCase';
import snakeCase from 'lodash/snakeCase';
import upperFirst from 'lodash/upperFirst';

import i18n from '@plugins/i18n';

import { tabKeys } from '@/views/Reports.vue';

export default [
    {
        path: '/reports',
        name: 'Reports',
        components: {
            default: () => import('@/views/Reports.vue'),
            sidebar: () => import('@/components/sidebars/ReportsSidebar.vue')
        },
        meta: {
            overline: i18n.t('reports'),
            title: i18n.t('_page.reports.heading'),
            heading: i18n.t('_page.reports.heading'),
            organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
            sidebarKey: 'reports-sidebar'
        },
        children: tabKeys.map(tab => ({
            path: kebabCase(tab),
            name: 'Reports' + upperFirst(camelCase(tab)),
            component: () => import('@/views/Reports' + upperFirst(camelCase(tab)) + '.vue'),
            meta: {
                overline: i18n.t('reports'),
                title: i18n.t('reports') + ' - ' + i18n.t('enums.reports_tabs.' + snakeCase(tab)),
                heading: i18n.t('enums.reports_tabs.' + snakeCase(tab)),
                organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                sidebarKey: 'reports-sidebar',
                retainQuerySelectors: ['investor_id', 'adviser_id', 'tax_year']
            }
        }))
    }
];
